import { Chip } from "@mui/material";

interface Props {
  value?: string | null;
}

export default function AccessTokenStateChip({ value }: Props) {
  const text = value || "-";
  const isExpired = text.toLowerCase().includes("expired");
  const isValid = text.toLowerCase().includes("valid");

  return (
    <Chip
      label={text}
      size="small"
      sx={{
        bgcolor: isExpired ? "#F79E1B26" : isValid ? "#4BA66326" : "#E5E7EB",
        color: isExpired ? "#F59E0B" : isValid ? "#16A34A" : "#6B7280",
        fontWeight: 600,
        maxWidth: 220,
        "& .MuiChip-label": {
          whiteSpace: "normal",
        },
      }}
    />
  );
}
